export default __webpack_public_path__ + "static/media/naver.525dffb5.png";